import { MARKET_MAP_PL, MARKET_MAP_PL_ERROR, MARKET_MAP_PL_HIDE_ERROR, MARKET_MAP_PL_START_LOADER, MARKET_MAP_PL_STOP_LOADER, } from "../interface/IMarketMapPl";
const initState = {
    data: [],
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const MarketMapPlReducer = (state = initState, action) => {
    switch (action.type) {
        case MARKET_MAP_PL: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case MARKET_MAP_PL_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MARKET_MAP_PL_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case MARKET_MAP_PL_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case MARKET_MAP_PL_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default MarketMapPlReducer;
